export const getTextFirstUpperLater = (text: string) => text.charAt(0).toUpperCase();
